/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
import { useQuery, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import {
    activeDataReconMenuVar, showDataReconMenusVar, showReportMenuVar, tenantIdVar, leftNavigationItemsVar, showCrossReportConfigVar, currentLeftMenuVar,
} from 'Apollo/config';
import { GET_PROJECT_HIERARCHY } from 'Apollo/Queries/DataRecon';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import Home from '../components/Home';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const HomeContainer = () => {
    const tenantVar = useReactiveVar(tenantIdVar);
    const location = useLocation();
    const history = useHistory();
    const [tenantId, setTenantId] = useState(tenantVar);
    const [showCreateProjectModal, setShowCreateProjectModal] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);

    useEffect(() => {
        setTenantId(tenantVar);
        showReportMenuVar(false);
        activeDataReconMenuVar('home');
        showDataReconMenusVar(true);
        showCrossReportConfigVar(false);
    }, [location.state]);

    /* apollo query to fetch lists of projects along with subprojects */
    const getProjectHierarchy = useQuery(GET_PROJECT_HIERARCHY, {
        variables: {
            input: {
                getProjectsType: 'ALL',
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    const mainDataProjectData = getProjectHierarchy.data && getProjectHierarchy.data.getProjectsHirachy && getProjectHierarchy.data.getProjectsHirachy.projects;

    const projectCount = getProjectHierarchy.data && getProjectHierarchy.data.getProjectsHirachy && getProjectHierarchy.data.getProjectsHirachy.projectsCount;

    const navigateToProjectTab = value => {
        history.push(
            {
                pathname: '/projects',
                state: {
                    tenantId,
                    // eslint-disable-next-line no-nested-ternary
                    filterValue: value,
                },
            },
        );
    };

    useEffect(() => {
        if (tenantVar) {
            setTenantId(tenantVar);
        }
    }, [tenantVar]);

    useEffect(() => {
        getProjectHierarchy.refetch();
    }, [tenantId]);

    return (
        <Home
            tenantId={tenantId}
            mainDataProjectData={mainDataProjectData}
            refetchProjectHierarchy={getProjectHierarchy.refetch}
            projectHierarchyIsLoading={getProjectHierarchy.loading}
            projectHierarchyIsError={getProjectHierarchy.error}
            showCreateProjectModal={showCreateProjectModal}
            setShowCreateProjectModal={setShowCreateProjectModal}
            navigateToProjectTab={navigateToProjectTab}
            projectCount={projectCount}
            toastMessage={toastMessage}
            setToastMessage={setToastMessage}
        />
    );
};

export default HomeContainer;
